// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3b1-r","name":"Header_name__lfdr0","birthday":"Header_birthday__36vC3","skeleton":"Header_skeleton__3tdwy"};